import { MARQUEE_ITEMS } from "./content";

const Row = ({ hidden = false }) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
        {MARQUEE_ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-serif text-lg italic text-gold-light sm:text-xl">
                    {item}
                </span>
                <span className="inline-block h-2 w-2 rotate-45 bg-gold/70" aria-hidden="true" />
            </span>
        ))}
    </div>
);

export default function Marquee() {
    return (
        <div
            className="relative overflow-hidden border-y border-gold/20 bg-pine-900/60 py-5"
            data-testid="editorial-marquee"
        >
            <div className="flex w-max animate-marquee">
                <Row />
                <Row hidden />
            </div>
        </div>
    );
}
